import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const ConservationProgressCard = ({ project }) => {
  const getStatusColor = (status) => {
    return status === 'Completed' 
      ? 'bg-[var(--color-success)] text-[var(--color-success-foreground)]' :'bg-[var(--color-info)] text-[var(--color-info-foreground)]';
  };

  return (
    <div className="bg-[var(--color-card)] rounded-lg overflow-hidden shadow-conservation hover:shadow-conservation-lg animation-organic border border-[var(--color-border)]">
      <div className="p-6">
        <div className="flex items-start justify-between mb-4">
          <div className="flex-1">
            <h3 className="text-lg font-semibold text-[var(--color-foreground)] mb-1">{project?.title}</h3>
            <div className="flex items-center gap-3 text-sm text-[var(--color-muted-foreground)]">
              <span className="flex items-center gap-1">
                <Icon name="MapPin" size={14} />
                {project?.location}
              </span>
              <span className="flex items-center gap-1">
                <Icon name="Calendar" size={14} />
                {project?.timeline}
              </span>
            </div>
          </div>
          <span className={`px-3 py-1 rounded-full text-xs font-medium ${getStatusColor(project?.status)}`}>
            {project?.status}
          </span>
        </div>

        <div className="mb-4">
          <div className="flex items-center justify-between text-sm mb-2">
            <span className="text-[var(--color-muted-foreground)]">Progress</span>
            <span className="font-semibold text-[var(--color-foreground)]">{project?.progress}%</span>
          </div>
          <div className="w-full bg-[var(--color-muted)]/30 rounded-full h-2.5">
            <div 
              className="bg-[var(--color-success)] h-2.5 rounded-full transition-all duration-500"
              style={{ width: `${project?.progress}%` }}
            />
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4 mb-4">
          <div className="relative h-32 rounded-lg overflow-hidden">
            <Image src={project?.beforeImage} alt={project?.beforeImageAlt} className="w-full h-full object-cover" />
            <div className="absolute bottom-2 left-2 bg-black/70 text-white px-2 py-1 rounded text-xs font-medium">
              Before
            </div>
          </div>
          <div className="relative h-32 rounded-lg overflow-hidden">
            <Image src={project?.afterImage} alt={project?.afterImageAlt} className="w-full h-full object-cover" />
            <div className="absolute bottom-2 left-2 bg-black/70 text-white px-2 py-1 rounded text-xs font-medium">
              After
            </div>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-3">
          {project?.metrics?.map((metric, index) => (
            <div key={index} className="flex items-center gap-2 p-2 bg-[var(--color-muted)]/30 rounded-lg">
              <Icon name={metric?.icon} size={16} className="text-[var(--color-primary)]" />
              <div>
                <p className="text-xs text-[var(--color-muted-foreground)]">{metric?.label}</p>
                <p className="text-sm font-semibold text-[var(--color-foreground)]">{metric?.value}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ConservationProgressCard;